export default __webpack_public_path__ + "static/journal-article-tablet-1b562bcf04031e083df052ca9389f5f4.png";